import { ajax } from "@/assets/js/ajax";
// export function getCollection(data) {     //案款金额列表
//   return ajax({
//     url: 'credit/payee/index',
//     type: 'get',
//     data: data
//   })
// }
export function getCollection(data) {
  //案款金额列表
  return ajax({
    url: "credit/payee/lists",
    type: "get",
    data: data,
  });
}

export function addCollection(data) {
  //新增案款
  return ajax({
    url: "credit/payee/add",
    type: "post",
    data: data,
    contentType: "application/json",
  });
}

export function getDebtorOption(data) {
  //选择框检索被告
  return ajax({
    url: "debtor/option",
    type: "get",
    data: data,
  });
}

export function getAnalyse(data) {
  //案款金额列表
  return ajax({
    url: "statis/analyse",
    type: "get",
    data: data,
  });
}

export function getChartStep(data) {
  //案款金额列表
  return ajax({
    url: "statis/analyse/step",
    // contentType: "application/json",
    data: data,
  });
}

export function getStepChart(data) {
  //案款金额列表
  return ajax({
    url: "statis/analyse/stepChart",
    // contentType: "application/json",
    data: data,
  });
}
// export function nGetStepChart(data) {     //案款金额列表
//   return ajax({
//     url: 'statis/cause_analyse/step_chart',
//     type: 'get',
//     data: data
//   })
// }
export function nGetStepChart(data) {
  return ajax({
    url: "statis/analyse2/step_chart",
    type: "get",
    data: data,
  });
}

export function stepChartCauseList(data) {
  return ajax({
    url: "statis/analyse/stepChartCauseList",
    // contentType: "application/json",
    data: data,
  });
}
// export function NstepChartCauseList(data) {
//   return ajax({
//     url: 'statis/cause_analyse/step_debtor_list',
//     type: 'get',
//     // contentType: "application/json",
//     data: data
//   })
// }
export function NstepChartCauseList(data) {
  return ajax({
    url: "statis/analyse2/step_debtor_list",
    type: "get",
    // contentType: "application/json",
    data: data,
  });
}
export function hkDetails(data) {
  return ajax({
    url: "credit/payee/info",
    type: "get",
    data: data,
  });
}
export function paylog(data) {
  return ajax({
    url: "credit/payee/log",
    type: "get",
    data: data,
  });
}
export function causeStepLog(data, type) {
  return ajax({
    url: type ? "credit/loan/audit" : "actionLog/causeStepLog",
    type: "get",
    data: data,
  });
}
// export function causeAnalyse(data) {
//   return ajax({
//     url: "statis/cause_analyse/index",
//     type: 'get',
//     data: data
//   })
// }
export function causeAnalyse(data) {
  return ajax({
    url: "statis/analyse2/index2",
    type: "get",
    data: data,
  });
}

export function analyseBook(data) {
  return ajax({
    url: "statis/analyse2/book",
    type: "get",
    data: data,
  });
}
export function debtorClear(data) {
  return ajax({
    url: "statis/debtorClear/index",
    type: "get",
    data: data,
  });
}
// export function outexport(data, type) {
//   return ajax({
//     url: type == 1 ? "export/stepCauseList" : "export/maxStepCauseList",
//     type: 'get',
//     data: data
//   })
// }

export function cpwsStatis(data) {
  return ajax({
    url: "statis/cpws/getData",
    type: "get",
    data: data,
  });
}

export function cpwsList(data) {
  return ajax({
    url: "statis/cpws/getDebtorList",
    type: "get",
    data: data,
  });
}

export function getDebtorList(data) {
  return ajax({
    url: "statis/dktOpen/getDebtorList",
    type: "get",
    data: data,
  });
}

export function statisDktFee(data) {
  return ajax({
    url: "statis/dktFee/getData",
    type: "get",
    data: data,
  });
}
export function statisDktFeeList(data) {
  return ajax({
    url: "statis/dktFee/getDebtorList",
    type: "get",
    data: data,
  });
}
